import { defineComponent as r, createBlock as t, openBlock as o, unref as v, mergeProps as d, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as h } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconReassuranceCalendar14Days",
  __name: "IconReassuranceCalendar14Days",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const n = l;
    return (s, a) => (o(), t(v(h), d(n, { "view-box": "0 0 48 48" }), {
      default: p(() => [...a[0] || (a[0] = [
        e("g", { "clip-path": "url(#x9b3vwa)" }, [
          e("path", { d: "M17.68 32.49v-9.88L15 24.48V22l2.76-2h2.41v12.49h-2.49" }),
          e("path", {
            "fill-rule": "evenodd",
            d: "M28.89 29.9v2.59l2.43-.04v-2.59h1.53v-2h-1.53V20h-2.91l-5.69 7.81v2.09h6.17m-3.71-2.04 3.71-5.18v5.18h-3.71",
            "clip-rule": "evenodd"
          }),
          e("path", {
            "fill-rule": "evenodd",
            d: "M32 6H16V2a2 2 0 1 0-4 0v4H5.83A5.87 5.87 0 0 0 0 11.9v30.2A5.87 5.87 0 0 0 5.83 48h36.34A5.87 5.87 0 0 0 48 42.1V11.9A5.87 5.87 0 0 0 42.17 6H36V2a2 2 0 1 0-4 0v4M5.83 10h36.34A1.87 1.87 0 0 1 44 11.9v30.2a1.87 1.87 0 0 1-1.83 1.9H5.83A1.87 1.87 0 0 1 4 42.1V11.9A1.87 1.87 0 0 1 5.83 10",
            "clip-rule": "evenodd"
          })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "x9b3vwa" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
